// extracted by mini-css-extract-plugin
export default {"errorBoundary":"ErrorBoundary_errorBoundary__wKVbP"};